// i18n area 'cluster' — locale is-IS (task #171, ratifica Luca 2026-08-04: l'islandese
// entra come 28ª lingua): tradotto DALL'ITALIANO (lingua SORGENTE, regola
// 2026-08-03). Glossario di sezione: rýmingaráætlun (piano di evacuazione),
// merkja/afmerkja (marcare/smarcare), fingrafar (fingerprint), raðnúmer
// (seriale), disksneið (partizione), samræming (riconciliazione), samleitnimörk
// (soglia di convergenza), kynslóð (generazione), lyklaborðsuppsetning (layout
// tastiera); restano invariati join, token→tóki, store member, quorum,
// heartbeat, authority, watermark, bond, VLAN, STP, passthrough, IOMMU,
// vfio-pci, CRUSH, OSD, YugabyteDB, overcommit.
// Sidecar anti-stantie: ../meta/cluster.is-IS.meta.json.
import type { enUS } from './cluster'

export const isIS: typeof enUS = {
  cluster: {
    // #233 — gli accessi di garanzia di un nodo (tradotto dall'italiano)
    nodeAccess: {
      title: 'Ábyrgðaraðgangar',
      subtitle: 'Þjónustudyr hnútsins: lesaðgangur með tímabundnu lykilorði og neyðarreikningurinn með lykilorðinu úr hirslunni',
      readOnlyTitle: 'Lesaðgangur (trantor)',
      stateNone: 'lokaður',
      stateGranted: 'opinn',
      stateGrantedPending: 'veittur — verið að virkja á hnútnum',
      grantedBy: 'Veittur af',
      grantedAt: 'Veittur',
      expiresAt: 'Rennur út',
      reason: 'Ástæða',
      endedAt: 'Lokaður',
      endedReason: {
        revoked: 'afturkallaður',
        expired: 'útrunninn (TTL)',
        reboot: 'endurræsing hnútsins',
        failed: 'ekki virkjaður (verk mistókst)'
      },
      grant: 'Veita lesaðgang…',
      grantTitle: 'Veita lesaðgang',
      grantSubmit: 'Veita',
      grantError: 'Veitingunni var hafnað',
      grantConfirm: 'TVirt býr til tímabundið lykilorð fyrir kerfisnotandann «trantor» (aðeins lestur: journal og greining, ekkert sudo) og setur það á hnútinn með verki. Lykilorðið er sýnt AÐEINS einu sinni, við staðfestingu; það rennur út á tímamörkum, við afturköllun eða við næstu endurræsingu hnútsins.',
      reasonLabel: 'Ástæða',
      reasonHint: 'Hvers vegna þú opnar dyrnar: það fer í veitinguna, í endurskoðunina og í dagbókina',
      ttlLabel: 'Tímalengd',
      ttlHours: '{n} klst.',
      revoke: 'Afturkalla lesaðgang…',
      revokeTitle: 'Afturkalla lesaðgang',
      revokeSubmit: 'Afturkalla',
      revokeError: 'Afturkölluninni var hafnað',
      revokeConfirm: 'Veitingin lýkur strax og verk læsir notandann «trantor» á hnútnum aftur: tímabundna lykilorðið hættir að virka.',
      passwordTitle: 'Lykilorð fyrir lesaðgang',
      passwordOnce: 'Þetta lykilorð er sýnt AÐEINS einu sinni: afritaðu það núna. Það er hvergi vistað og ekki er hægt að lesa það aftur — ef þú týnir því, veittu aftur.',
      passwordUser: 'Notandi',
      passwordLabel: 'Lykilorð',
      passwordHint: 'Gildir til {until} eða til næstu endurræsingar hnútsins; nothæft þegar veitingarverkinu er lokið. Aðgangur: ssh trantor@<vistfang hnútsins>.',
      emergencyTitle: 'Síðasti neyðaraðgangur (trantor-emergency)',
      lastLogin: '{time} um {via} frá {from}',
      lastLoginNone: 'enginn séður',
      lastLoginVia: {
        ssh: 'ssh',
        console: 'stjórnborð',
        sudo: 'sudo',
        unknown: 'óþekkt'
      },
      emergencyHint: 'Neyðarreikningurinn «trantor-emergency» (fullt sudo) er alltaf virkur með lykilorðinu sem var búið til við uppsetningu hnútsins og geymt í hirslunni: TVirt þekkir það ekki, skiptir því ekki út og endurheimtir það ekki. Hver innskráning er tilkynnt hér og í atburðadagbókinni.'
    },
    nodeFirewall: {
      tab: 'Eldveggur',
      title: 'Eldveggur hnútanna',
      subtitle: 'Staða nftables-ruleset sem hver hnútur beitir á sjálfan sig — eini eldveggur hnúts (firewalld er óvirkt)',
      modeLabel: 'Staða',
      mode: {
        disabled: 'Óvirkt — ekkert ruleset á hnútunum',
        permissive: 'Leyfandi — telur og skráir, fleygir engu',
        enforced: 'Framfylgt — aðeins afleidda skráin kemst inn'
      },
      hint: {
        disabled: 'Eins og í dag: hnútarnir bera ekkert ruleset. Skiptu yfir í leyfandi til að LESA hvað yrði fleygt áður en því er fleygt.',
        permissive: 'Hver hnútur beitir sínu afleidda ruleset með policy accept: því sem framfylgda staðan myndi fleygja er talið og skráð (journal-forskeyti „tvirt-node would-drop:“). Ekkert er hindrað.',
        enforced: 'Hver hnútur beitir sínu afleidda ruleset með policy drop: ssh og API hvaðan sem er, store / live migration / overlay / Ceph aðeins frá meðlimunum, hlustarar netþjónustanna frá netinu sem þær þjóna. Hvert skipti er apply með staðfestingu — hnútur sem nær ekki að staðfesta fer sjálfur til baka.'
      },
      confirmTitle: 'Framfylgja eldvegg hnútanna?',
      confirmBody: 'Hver hnútur beitir ruleset-inu með staðfestingu: hann kannar backend, store og ssh gegnum nýju reglurnar innan frestsins og staðfestir — annars fer hann sjálfur til baka í fyrra ruleset. Lestu fyrst teljara leyfandi stöðunnar á hnútunum.',
      confirmSubmit: 'Framfylgja',
      confirmCancel: 'Hætta við',
      lensTitle: 'Eldveggur hnútsins',
      loadError: 'Tókst ekki að hlaða eldveggslinsu hnútsins',
      noReport: 'Engin eldveggsskýrsla frá þessum hnút, ennþá — worker-inn skilar við næstu umferð',
      firewalldActive: 'Á þessum hnút keyrir firewalld: eldveggur hnútsins neitar að beita sér við hlið þess (settu mask á firewalld)',
      conditionUnconfirmed: 'Ekkert ruleset staðfest, ennþá — hnúturinn er opinn',
      conditionRolledBack: 'Síðasta apply fór til baka — sama kynslóð er ekki reynd aftur fyrr en skráin breytist eða stöðunni er skipt á ný',
      lastError: 'Síðasta villa',
      posture: 'Staða',
      observedAt: 'Athugað',
      desiredGeneration: 'Óskuð kynslóð',
      componentTitle: 'Hnútsíhlutur',
      componentSubtitle: 'tvirt-node-firewall — beitir staðfesta ruleset-inu við ræsingu, tekur óstaðfest sjálfur til baka',
      componentAbsent: 'Íhluturinn hefur ekki enn skilað skýrslu',
      phase: 'Fasi',
      phases: {
        none: 'Aldrei beitt',
        applied: 'Beitt — bíður staðfestingar',
        confirmed: 'Staðfest',
        rolledBack: 'Farið til baka'
      },
      generation: 'Kynslóð',
      appliedAt: 'Beitt þann',
      confirmedAt: 'Staðfest þann',
      deadline: 'Rollback-frestur',
      lastRollback: 'Síðasta rollback',
      registryTitle: 'Afleidd skrá',
      registrySubtitle: 'Portin sem þessi hnútur opnar, eftir flokki og uppruna — afleidd af klasanum, aldrei breytt í höndunum',
      registryEmpty: 'Ekkert afleitt — staðan óvirk án staðfests ruleset, eða engin skýrsla ennþá',
      colClass: 'Flokkur',
      colPort: 'Port',
      colSource: 'Uppspretta',
      colOrigin: 'Uppruni',
      classes: {
        public: 'Opinber',
        internode: 'Milli hnúta',
        tenant: 'Tenant'
      },
      sourceMembers: 'aðeins meðlimirnir',
      sourceAnywhere: 'hvaðan sem er',
      sourceBridge: 'á {iface}'
    },
    derivationDerived: 'afleitt',
    derivationDiverged: 'frávikið',
    derivationDerivedTip: 'Netskjalið er AFLEITT af fabric {fabric} og passar enn við renderið á núverandi inntaki — smelltu fyrir afleiðsluáætlunina.',
    derivationDivergedTip: 'Afleiðslan frá fabric {fabric} breyttist eftir síðasta apply (fabric, köplun, hlutverk eða tilvísanir) — smelltu fyrir diffið í bið.',
    derivationRetiring: {
      one: '{n} vistfang að tæmast',
      other: '{n} vistföng að tæmast'
    },
    standaloneHint: 'Þessi hnútur á engan klasa: hann hefur ekki enn verið settur upp. Klasar eru búnir til EÐA joinaðir við uppsetningu — tókinn sem Þjónar-tafla meðlims býr til er gefinn uppsetningarforritinu (dev: db:init-cluster / db:init-join).',
    reducedHint: 'Heimildir þínar ná yfir eitt scope, ekki allan klasann: floti klasans — hnútar, stillingar og tæki — er aðeins sýnilegur þeim sem stjórna klasanum.',
    phaseReady: 'Tilbúinn',
    phaseForming: 'Í mótun',
    storeMembers: 'Meðlimir gagnageymslunnar',
    watermark: 'Samleitnimörk',
    configGeneration: 'Stillingakynslóð',
    converged: 'samstíga',
    behind: 'á eftir — {m} / {n}',
    revision: 'Útgáfa',
    rolesTitle: 'Nethlutverk',
    rolesSubtitle: 'Vistföng fyrir hvern meðlim í hverjum umferðarflokki — tengingin býr í hýsilnetinu',
    roleManagement: 'Management',
    roleLiveMigration: 'Live Migration',
    roleInherited: 'erfir management',
    settingsTitle: 'Stillingar',
    settingsSubtitle: 'Öryggisstefna á klasastigi — metin af hverjum hnút út frá staðbundinni speglun hans',
    taskRetentionTitle: 'Varðveisla verka',
    taskRetentionSubtitle: 'Sameinuð GC fyrir öll verk — lokin verk umfram aldur eða þak eru sópuð upp, aldrei þau sem eru í gangi',
    taskRetentionMaxAge: 'Hámarksaldur (dagar)',
    taskRetentionMaxCount: 'Hámarksfjöldi verka',
    eventRetentionTitle: 'Varðveisla atburða',
    eventRetentionSubtitle: 'GC dagbókarinnar — stefna óháð verkefnunum: verkefnið er biðröð, atburðurinn er minni',
    eventRetentionMaxAge: 'Hámarksaldur (dagar)',
    eventRetentionMaxCount: 'Hámarksfjöldi geymdra atburða',
    spaceThresholdsTitle: 'Plássþröskuldar',
    spaceThresholdsSubtitle: 'Hvenær geymsla sem fyllist ratar í dagbókina (og tilkynningarnar)',
    spaceLowPct: 'Viðvörun frá (% notað)',
    spaceCriticalPct: 'Alvarlegt frá (% notað)',
    spaceOrderError: 'Alvarlegt getur ekki verið undir viðvöruninni',
    spaceThresholdsHint: 'Aðeins inngangarnir eru stilltir: útganginn leiðir vélin af, 5 stigum undir hverjum þröskuldi, svo geymsla á línunni verði aldrei að taktmæli',
    failoverReserveTitle: 'Failover-forði',
    failoverReserveSubtitle: 'Inntökustýring N+1 — vinnsluminni haldið lausu svo klasinn geti endurræst álag sitt eftir missi hnúta',
    failoverReserveTolerate: 'Hnútar sem þola á að missa',
    failoverReserveOff: '0 — forðinn óvirkur: engri ræsingu er nokkurn tíma hafnað vegna failover-getu',
    failoverReserveOn: 'Ræsingu sem gengi á forðann er hafnað með 412 sem útskýrir tölurnar',
    networkShapingTitle: 'Sanngirni bandbreiddar',
    networkShapingSubtitle: 'Þrjú gerðarvægi shaping-trésins fyrir hvern uplink — þau virka aðeins þegar keppt er um bandbreidd',
    networkShapingRest: 'Vægi afgangsins (stjórnlag, storage, afrit)',
    networkShapingOverlay: 'Vægi overlay-neta',
    networkShapingLiveMigration: 'Vægi live migration',
    networkShapingHint: 'Tryggður hlutur = vægi / summa þriggja (sjálfgefið 300 / 100 / 200, hvert frá 1 til 10000); á lausum tengli má hver flokkur taka alla bandbreiddina',
    debugModeTitle: 'Debug-hamur',
    debugModeSubtitle:
      'Nákvæmar villur í almennum GUI-tilkynningum — til að sjá raunverulegu ástæðuna þegar aðgerð sem „mistókst“ heppnaðist í raun',
    debugModeLabel: 'Debug-hamur virkur',
    debugModeOn: 'Almennar villutilkynningar bæta við undirliggjandi ástæðu — innri smáatriði sýnileg hverjum notanda',
    debugModeOffHint: 'Óvirkt — almennar villutilkynningar haldast almennar, án innri smáatriða',
    nodeDetailsAction: 'Nánar um hnút',
    node: {
      docTitle: 'Hnútur',
      notFound: 'Hnútur fannst ekki',
      tabOverview: 'Yfirlit',
      tabStats: 'Tölfræði',
      tabNetwork: 'Net',
      tabSettings: 'Staðbundnar stillingar',
      identityTitle: 'Auðkenni',
      heartbeatTitle: 'Heartbeat',
      ysqlPort: 'YSQL-port',
      revision: 'Stillingaútgáfa',
      versionsTitle: 'Athugaðar útgáfur',
      heartbeatSubtitle: 'Síðasta staðan sem hnúturinn tilkynnti um sjálfan sig',
      cpuTitle: 'CPU',
      cpuModelTitle: 'CPU-gerð',
      memoryTitle: 'Minni',
      hugePagesTitle: 'Risasíður',
      hugePagesPool: '{size}: {free} lausar af {total}',
      hugePagesNone: 'Ekkert pool',
      hugePagesNoneHint: 'Hnúturinn á engar fráteknar risasíður: VM sem biðja um þær geta ekki ræst hér. Pool-ið er lýst yfir á hnútnum, með kjarnastikunum hugepagesz og hugepages eða með því að skrifa nr_hugepages.',
      usageTitle: 'Núverandi notkun',
      usageMem: 'Vinnsluminni {n} MiB',
      usageUnknown: 'ekki athugað — ekkert ferskt sýni',
      statsNoData: 'Engin gögn á bilinu — raðir hnútsins eru mældar af hnútnum sjálfum og bornar fram staðbundið.',
      observedTitle: 'Athugað ástand',
      observedSubtitle: 'Þjónustur og staðbundnar eignir hnútsins, eins og worker-inn sér þær'
    },
    editRolesTitle: 'Breyta nethlutverkunum',
    memberNode: 'Hnútur',
    memberIp: 'IP-tala',
    addMember: 'Bæta við meðlim',
    lmInherit: 'Nota management-vistföngin',
    roleIpHint: 'Frjálst er að bæta við og fjarlægja meðlimi; að breyta IP-tölu fyrirliggjandi meðlims á staðnum er hafnað — IP-flutningsflæðið kemur í síðara round.',
    roleError: 'Ekki tókst að uppfæra hlutverkin',
    nodesTitle: 'Hnútar',
    addNodeTitle: 'Bæta hnút við klasann',
    addNode: 'Bæta við hnút',
    addNodeError: 'Ekki tókst að forskrá hnútinn',
    nodeName: 'Nafn hnútsins',
    nodeNameHint: 'verður að stemma við nafnið sem valið var við uppsetningu',
    nodeIp: 'Management-IP',
    colName: 'Nafn',
    colPhase: 'Fasi',
    colServices: 'Þjónustur',
    colWatermark: 'Watermark',
    colLastSeen: 'Síðasta samband',
    colUps: 'UPS',
    upsCordonChip: 'UPS-girðing',
    upsCordonTip: 'Hnúturinn dæmdi sjálfan sig út frá staðreyndum UPS-tækisins ({time}): hann fjarlægir girðinguna sjálfur þegar rafmagnið er stöðugt og rafhlaðan hlaðin',
    upsUnreachable: 'UPS ónáanlegt',
    upsOnBattery: 'Á rafhlöðu',
    upsOnLine: 'Á rafmagni',
    upsLowBattery: 'lítil rafhlaða',
    upsNoEstimateChip: 'keyrslutími ekki áætlaður',
    upsNoEstimateTip: 'UPS-tækið birtir ekki áætlaðan keyrslutíma: hnúturinn er aðeins dæmdur út frá LB-fána (lítil rafhlaða) UPS-tækisins — stillið battery.runtime.low / LB á UPS-tækinu sjálfu',
    upsLaneTip: 'UPS-slökkvunarleið síðan {since}: dæmdur af {by}',
    upsUnit: 'eining',
    upsStatus: 'NUT-staða',
    upsLoad: 'álag',
    upsOnBatterySince: 'á rafhlöðu síðan',
    upsOnLineSince: 'á rafmagni síðan',
    upsError: 'villa',
    upsObservedAt: 'athugað',
    upsNone: 'engin UPS-eining þjónar þessum hnút',
    upsBy: {
      runtime: 'keyrslutími undir mörkum',
      lowBattery: 'LB-fáni UPS-tækisins',
    },
    upsLane: {
      evacuate: 'rýming',
      local: 'slökkt á staðnum',
    },
    upsPhase: {
      draining: 'drain',
      stoppingGuests: 'stöðvar gesti',
      stoppingServices: 'stöðvar þjónustur',
      poweredOff: 'slökkt',
    },
    upsTitle: 'UPS (NUT)',
    upsSubtitle: 'UPS-einingar og mörk: hnútur dæmdur við keyrslutíma ≤ mörk eða LB-fána (alltaf virtur), endurræsing með hysteresu',
    upsRuntimeThreshold: 'Mörk keyrslutíma (s)',
    upsRuntimeThresholdHint: 'Á rafhlöðu með áætlaðan keyrslutíma ≤ mörk slekkur hnúturinn í röð (sjálfgefið 300)',
    upsResumeStable: 'Rafmagn stöðugt í (s)',
    upsResumeStableHint: 'Endurræsing aðeins með samfelldu rafmagni í að minnsta kosti svo margar sekúndur (sjálfgefið 60)',
    upsResumeCharge: 'Lágmarkshleðsla við endurræsingu (%)',
    upsResumeChargeHint: 'Og rafhlaða hlaðin að minnsta kosti í þetta hlutfall (sjálfgefið 25)',
    upsPolicyNote: 'LB-fáni (lítil rafhlaða) UPS-tækisins dæmir alltaf og er ekki hægt að slökkva á; engin mörk eru á tíma á rafhlöðu. Hver eining getur yfirskrifað tölurnar þrjár.',
    upsUnitNew: 'ný eining',
    upsUnitSelectors: '{n} merkjaval (aðeins CLI)',
    upsUnitName: 'Nafn einingar',
    upsUnitMode: 'Hamur',
    upsModeExternal: 'ytri (annarra upsd)',
    upsModeManaged: 'stýrð (UPS tengt við hnút)',
    upsUnitUpsname: 'NUT-nafn (upsname)',
    upsUnitHost: 'upsd-hýsill',
    upsUnitAttachedNode: 'Tengdur hnútur',
    upsUnitDriver: 'NUT-rekill',
    upsUnitDriverHint: 'usbhid-ups, nutdrv_qx, snmp-ups, …',
    upsUnitDevice: 'Tæki rekilsins',
    upsUnitDeviceHint: 'línan port= í ups.conf: tómt = auto',
    upsUnitPort: 'upsd-gátt',
    upsUnitServedNodes: 'Þjónaðir hnútar',
    upsUnitServedNodesHint: 'nöfn hnúta aðskilin með kommum (merkjaval fer í gegnum CLI)',
    upsUnitOverrideHint: 'tómt = sjálfgefið klasans',
    upsUnitAdd: 'Bæta við einingu',
    unreachableSince: 'Ónáanlegur — síðasta heartbeat {time}',
    overlaysChip: 'overlay',
    overlaysBehind: 'Overlay-dataplaninn hefur ekki enn framkvæmt núverandi overlay-stillingar',
    overlaysError: 'Síðasta overlay-samræmingarumferð mistókst: {error}',
    storeChip: 'store',
    phase: {
      'pending-join': 'Bíður eftir join',
      'joining': 'Í join',
      'member': 'Meðlimur'
    },
    tokenTitle: 'Join-tóki',
    tokenOnce: 'Aðeins sýndur núna — afritaðu hann strax, hann verður ekki læsilegur aftur',
    copy: 'Afrita',
    copied: 'Afritað',
    close: 'Loka',
    revokeTitle: 'Afturkalla forskráningu',
    revoke: 'Afturkalla',
    revokeError: 'Ekki tókst að afturkalla skráninguna',
    promote: 'Gera að store member',
    demote: 'Fjarlægja store-member hlutverkið',
    troubleshoot: 'Úrræðaleit',
    promoteTitle: 'Gera að store member',
    demoteTitle: 'Fjarlægja store-member hlutverkið',
    promoteHint: 'Hnúturinn gengur inn í quorum YugabyteDB-masteranna. Raunveruleg HA krefst þriggja store member.',
    demoteHint: 'Hnúturinn gengur út úr quorum masteranna og stöðvar store-þjónustur sínar.',
    storeError: 'Breytingu á store-member var hafnað',
    attest: 'Staðfesta slökktan…',
    attestTitle: 'Staðfesta hnút slökktan',
    attestSubmit: 'Staðfesta slökktan',
    attestConfirm: 'Þú ert að lýsa þennan hnút slökktan, á eigin ábyrgð: að staðfesta hnút sem er í raun lifandi hættir á VM í tvöfaldri keyrslu. Verk hans eru felld og authority-ar VM-anna hans verða flytjanlegir.',
    attestError: 'Staðfestingunni var hafnað',
    attestedChip: 'staðfestur slökktur',
    maintenanceChip: 'viðhald',
    guestToolsChip: 'TVirt Guest Tools (ISO-eign staðbundin á hnútnum)',
    maintenanceEnter: 'Virkja viðhald',
    maintenanceExit: 'Afvirkja viðhald',
    maintenanceEnterTitle: 'Virkja viðhald',
    maintenanceExitTitle: 'Afvirkja viðhald',
    maintenanceEnterSubmit: 'Virkja viðhald',
    maintenanceExitSubmit: 'Afvirkja viðhald',
    maintenanceEnterConfirm: 'Hnúturinn er girtur af og tæmdur: netþjónusturnar og App-tilvikin sem hann heldur authority fyrir eru flutt (tilvikin köld: stöðvuð og slegin hér, endursköpuð á markhnútnum — niðurtími), keyrandi VM eru fluttar í beinni þar sem hægt er og annars stöðvaðar snyrtilega, verkefni í vinnslu klárast, ný vinna bíður og stöðvaðar VM missa authority sitt — Proximity staðsetur þær aftur við næstu ræsingu. Ekkert kemur til baka af sjálfu sér þegar viðhaldi lýkur.',
    maintenanceExitConfirm: 'Hnúturinn tekur aftur til starfa og Proximity fer aftur að taka hann með í staðsetningu. VM-arnar koma aðeins aftur þegar þær eru ræstar.',
    maintenanceError: 'Viðhaldsbeiðninni var hafnað',
    maintenancePlanTitle: 'Rýmingaráætlun',
    maintenancePlanLoading: 'Reikna rýmingaráætlunina…',
    maintenancePlanError: 'Ekki tókst að sækja rýmingaráætlunina — tæmingin mun samt flytja þar sem hægt er og stöðva afganginn.',
    maintenancePlanEmpty: 'Ekkert að rýma á þessum hnút — engin virk netþjónusta, ekkert App-tilvik sem óskað er keyrandi, engin keyrandi VM.',
    maintenancePlanSummary: '{migrate} hlutir flytjast (VM, netþjónustur, App-tilvik), {stop} stöðvast eða verða þar sem þeir eru.',
    maintenancePlanReserve_ok: 'Failover-forðinn eftir tæminguna: heill — {headroom} GiB haldast ræsanleg með þoli fyrir missi {n} hnúts/hnúta.',
    maintenancePlanReserve_eroded: 'Failover-forðinn eftir tæminguna: næstum uppurinn — aðeins {headroom} GiB eftir af {reserve} GiB sem haldið er lausum fyrir {n} hnútabilun/-bilanir.',
    maintenancePlanReserve_exhausted: 'Failover-forðinn eftir tæminguna: UPPURINN — {headroom} GiB vantar af {reserve} GiB sem þarf til að þola {n} hnútabilun/-bilanir. Meðan þessi hnútur er úti verður nýjum VM-ræsingum hafnað.',
    maintenancePlanReserve_unknown: 'Failover-forðinn eftir tæminguna: ekki reiknanlegur — enginn eftirstandandi hnútur hefur gefið upp minni sitt.',
    maintenancePlanReserveHugePages: 'Risasíður af stærð {size} eftir tæminguna — lausar: {free} af {capacity}, krafist sem forði: {reserve}.',
    maintenancePlanActionMigrate: 'flyst',
    maintenancePlanActionMigrateWarning: 'flyst (mjúk regla brotin)',
    maintenancePlanActionStop: 'stöðvast',
    maintenancePlanActionBlocked: 'blokkuð',
    maintenancePlanKindVm: 'VM',
    maintenancePlanKindNetsvc: 'netþjónusta',
    maintenancePlanKindApp: 'App-tilvik',
    maintenancePlanColdMove: 'Kaldur flutningur: podið er stöðvað og slegið hér og endurskapað á markhnútnum af worker hans — niðurtími fram að næsta pass markworkersins.',
    caFingerprint: 'Fingrafar CA klasans',
    staleChip: 'ekki uppfært',
    troubleshootTitle: 'Úrræðaleit gagnageymslunnar',
    restartStore: 'Endurræsa store-þjónusturnar',
    restartHint: 'Ef gagnageymslan hagar sér illa, endurræstu þjónustur hennar. Ítarlegt — notist með varúð.',
    restartQueued: 'Endurræsingarverk í biðröð',
    restartError: 'Ekki tókst að endurræsa þjónusturnar',
    svcActive: 'virk',
    svcWanted: 'óskuð, ekki virk',
    svcStopped: 'stöðvuð',
    noServices: 'Engin þjónusta tilkynnt'
  },
  clusterDevices: {
    gpusTitle: 'GPU / PCIe',
    gpusSubtitle: 'GPU-yfirlit alls klasans flokkað eftir gerð — kortin athuguð eftir hnútum, með merktu skráningunum og merkjum þeirra',
    usbTitle: 'USB-auðlindir',
    usbSubtitle: 'USB-yfirlit alls klasans flokkað eftir gerð — tækin athuguð eftir hnútum, með skráningum beggja líkana (eftir tæki, eftir porti) og merkjum þeirra',
    markedChip: '{n} nothæf fyrir TVirt',
    orphanChipGpu: '{n} munaðarlaus',
    orphanChipUsb: '{n} munaðarlaus',
    colNode: 'Hnútur',
    colRegistration: 'Skráning',
      noRegsHint: 'Engin skráning — tækið er merkt „nothæft fyrir TVirt“ úr glugga hnútsins (Hnútar › hnútur › Stillingar).',
      colDevice: 'Tæki',
      colObserved: 'Athuguð',
      colRegs: 'Skráningar',
      regsNone: 'engin',
      colPci: 'PCIe-vistfang',
      colIdentity: 'Auðkenni / port',
      colClasses: 'Flokkar (merki)',
      colActions: 'Aðgerðir',
      manageOnNode: 'Stjórna á hnútnum {node} (merkingin býr í glugga hnútsins)',
      introTitle: 'Klasayfirlit USB- og PCIe-tækja nothæfra fyrir TVirt©.',
      introStep1: '1. Hnútarnir uppgötva sjálfir sínar GPU og USB-tæki (talning í heartbeat-inu).',
      introStep2: '2. Tæki er merkt „nothæft fyrir TVirt“ úr glugga HNÚTSINS (Hnútar › hnútur › Stillingar) — merkingin bindur það við vfio og skráir það hér.',
      introStep3: '3. Hér gefurðu skráningunum FLOKKA sína gegnum merki (t.d. gpu_class=compute): kröfur VM-anna munu biðja um flokk, og scheduler-inn velur hnút með lausu samhæfu tæki.',
    colMode: 'Líkan',
    colState: 'Staða',
    colNotes: 'Minnispunktar',
    colTags: 'Merki',
    modeDevice: 'eftir tæki',
    modePort: 'eftir porti',
    usable: 'nothæft',
    orphanGpu: 'munaðarlaus',
    orphanUsb: 'munaðarlaust',
    hubChip: 'hub',
    orphanPortsTitle: 'Skráningar eftir porti án tengds tækis — tengdu tæki aftur eða afmerktu þær frá hnútnum',
    gpusEmpty: 'Engin GPU enn athuguð á neinum hnút',
    usbEmpty: 'Ekkert USB-tæki enn athugað á neinum hnút'
  },

  // Vocabolario condiviso dei form impostazioni (refactoring 2026-07-24): i campi
  // security alimentano la card della pagina Cluster, i campi nodo la pagina
  // node-settings — la pagina /system/settings per cui nacquero è morta.
  settings: {
    passwordMinLength: 'Lágmarkslengd lykilorðs',
    sessionIdle: 'Tímamörk aðgerðalausrar setu (mínútur)',
    lockoutThreshold: 'Læsing eftir misheppnaðar tilraunir',
    lockoutDuration: 'Lengd læsingar (mínútur)',
    keyboardLayout: 'Lyklaborðsuppsetning',
    keyboardLayoutHint: 't.d. is, en-us — autt fyrir sjálfgefið QEMU-gildi',
    syslogEndpoint: 'Syslog-endapunktur',
    syslogEndpointHint: 'hýsill:port — autt til að slökkva á áframsendingunni',
    syslogTls: 'TLS',
    maxQueued: 'Hámark verka í biðröð',
    concurrency: 'Samhliðni worker-sins',
    concurrencyHint: 'Tekur gildi á flugi hjá worker-num',
    notesTitle: 'Minnispunktar',
    save: 'Vista',
    saved: 'Stillingar vistaðar',
    saveError: 'Ekki tókst að vista stillingarnar'
  },
  localSettings: {
    derivedChip: 'afleitt',
    derivedTip: 'Þetta device er Í EIGU fabric-afleiðslunnar (H2): ritillinn neitar að snerta það — breyttu fabric (eða köplun) og beittu aftur, eða taktu það til baka hér að neðan.',
    takeOwnership: 'Taka eignarhald',
    takeOwnershipTitle: 'Taka eignarhald (take-ownership)',
    takeOwnershipConfirm: '{name} yfirgefur fabric-blokkina og verður aftur HANDVIRKT device sem þessi ritill stjórnar. Hnúturinn verður frávikinn og næsta afleiðslu-apply synjar á honum (manualConflict) þar til þú endurnefnir eða fjarlægir það — eða lagar fabric.',
    nodeSettingsTitle: 'Stillingar hnútsins',
    nodeSettingsSubtitle: 'Það sem þessi hnútur framfylgir — verkröðin, stjórnskjárinn, annálaáframsending — auk merkja hans og minnispunkta',
    baseTitle: 'Hýsilforðar (TVirt Proximity)',
    baseSubtitle: 'CPU og vinnsluminni frátekið fyrir stýrikerfi hýsilsins — inntök raungetunnar sem Proximity staðsetur VM-arnar með',
    baseMemory: 'Grunnvinnsluminni (MiB)',
    baseMemoryHint: 'Athugað heildarminni: {total} MiB. Nothæft fyrir VM = heild − grunnur − vinnsluminni kveiktra VM-a staðsettra hér.',
    baseMemoryHintNoTotal: 'Nothæft fyrir VM = athuguð heild − grunnur − vinnsluminni kveiktra VM-a staðsettra hér.',
    baseCpu: 'CPU-grunnkjarnar',
    baseCpuHint: 'Athugaðar rökrænar CPU: {total}. Aðeins notað sem röðunarvægi — vCPU-overcommit er eðlilegt.',
    baseCpuHintNoTotal: 'Aðeins notað sem röðunarvægi — vCPU-overcommit er eðlilegt.',
    baseHint: 'Vinnsluminnið er harða inntökuhliðið: VM sem kemst ekki fyrir í nothæfu minni er hafnað með villu sem segir hvers vegna. Hækkaðu grunninn á hýslum sem hýsa meðlimi gagnageymslunnar eða Ceph-púka.',
    placementTitle: 'Efnisleg staðsetning',
    placementSubtitle: 'Hvar þessi þjónn stendur í raun — lýst yfir einu sinni, hvað sem þarf á að halda',
    placementHint: 'Staðsetningin stýrir CRUSH-stigveldi hvers Ceph-klasa með OSD á þessum þjóni: að vista breytingu endurstillir kortin þeirra gegnum verk (host → rack → … → root). Hlutayfirlýsingar eru löglegar — tóm stig falla saman. Nöfnin eru sameiginleg yfir allt kortið: tveir þjónar í sama rekka lýsa yfir sama rekkanafni.',
    placementNameInvalid: 'DNS-öruggt nafn (lágstafir, tölustafir, bandstrik)',
    placementEmpty: 'Autt = ekki yfirlýst',
    placementLevel: {
      chassis: 'Grind',
      rack: 'Rekki',
      row: 'Röð',
      pdu: 'PDU',
      pod: 'Pod',
      room: 'Herbergi',
      datacenter: 'Gagnaver',
      zone: 'Svæðishluti',
      region: 'Landsvæði'
    },
    cablingTitle: 'Lagnir',
    cablingSubtitle: 'Við hvaða port skiptisins hvert tengi er tengt — yfirlýsingin býr á hnútnum (Annex O.9)',
    cablingHint: 'Ein snúra á NIC, ein snúra á port yfir allan flotann (API hafnar og nefnir handhafann). Að leggja í port sem er meðlimur í LAGG er löglegt — það er bond-tilfellið: framtíðarleiðslan birtir það sem LACP.',
    cablingInterface: 'Tengi',
    cablingNotCabled: '— ekki tengd —',
    cablingNoInterfaces: 'Ekkert nettengi athugað',
    disksTitle: 'Diskar',
    disksSubtitle: 'Athuguð blokkartæki — ein skönnun á hverri samræmingarumferð; merktu hér diskana nothæfa sem Ceph-OSD (N.15: hæfið er skýrt)',
    colDataDisk: 'Gagnadiskur',
    dataDisksHint: 'Að haka við tæki lýsir það nothæft sem OSD; raðnúmerið er auðkennispinni þess — afritað frá vélbúnaðinum þegar diskurinn gefur það upp, myntað (tvirt-…) annars. Ceph-skráningarglugginn býður aðeins yfirlýstu diskana.',
    diskDeclaredSerial: 'yfirlýst',
    diskNotObserved: 'yfirlýstur en ekki athugaður — tengdu tækið aftur eða taktu hakið af',
    noDisks: 'Ekkert blokkartæki enn athugað',
    colSerial: 'Raðnúmer',
    colModel: 'Gerð',
    colSize: 'Stærð (GiB)',
    colDiskType: 'Tegund',
    colInUse: 'Í notkun',
    colObservedAt: 'Athugaður',
    diskInUse: 'í notkun',
    diskFree: 'laus',
    diskMounted: 'tengdur',
    diskPartitions: 'disksneiðar',
    passthroughTitle: 'Passthrough-tæki',
    passthroughSubtitle: 'Athugaðar GPU og USB-tæki — merktu hér hvað TVirt má rétta VM-unum; merkingin skráir auðkenni tækisins (round U1+G1)',
    passthroughHint: 'Merkingin skráir tækið (stöðugt auðkenni — viðfang merkja og flokkakrafna). Merkt GPU fær ALLAN IOMMU-hópinn bundinn við vfio-pci í heilu lagi — hún yfirgefur hýsilinn strax; afmerking tengir upprunalega rekilinn aftur. Fyrir USB eru bæði staðfestu líkönin til: eftir tæki (framleiðandi+vara, hvar sem það er tengt) og eftir efnislegu porti (VM-in fær hvað sem er stungið í það). USB er ekki bundið við merkingu — tengingin gerist við keyrslu VM-arinnar.',
    passthroughGpusTitle: 'GPU / PCIe',
    passthroughUsbTitle: 'USB',
    colUsable: 'Nothæft fyrir TVirt',
    colGpu: 'GPU',
    colPciAddress: 'PCI-vistfang',
    colDriver: 'Rekill',
    colVerdict: 'Úrskurður',
    gpuEligible: 'Hæf',
    gpuIneligible: 'Óhæf',
    gpuReason: {
      'no-iommu': 'IOMMU ekki virkt á hýslinum',
      'group-spans-slots': 'IOMMU-hópur ekki einangraður: nær yfir aðrar raufar',
      'multiple-display': 'IOMMU-hópur ekki einangraður: fleiri en eitt myndúttak',
      'foreign-function': 'IOMMU-hópur ekki einangraður: inniheldur óskylda virkni'
    },
    vfioNotReady: 'IOMMU er ekki virkt á þessum hýsli: engin GPU er hæf fyrr en hýsilvettvangurinn virkjar það (OEM-ISO) — TVirt snertir aldrei kjarnastikur í keyrslu.',
    vfioMissingKernelArg: 'IOMMU er ekki virkt á þessum hýsli: fastbúnaðurinn gefur upp VT-d/AMD-Vi (ACPI-tafla DMAR/IVRS til staðar) en kjarnastikuna vantar — bættu við intel_iommu=on (Intel) eða fjarlægðu amd_iommu=off (AMD) af skipanalínu kjarnans og endurræstu. TVirt snertir aldrei kjarnastikur í keyrslu.',
    vfioFirmwareDisabled: 'IOMMU er ekki virkt á þessum hýsli: VT-d/AMD-Vi er óvirkt í fastbúnaðinum (engin ACPI-tafla DMAR/IVRS) eða CPU-ið styður það ekki — virkjaðu það í fastbúnaðaruppsetningunni, engin kjarnastika getur kveikt á því. TVirt snertir aldrei hýsilinn í keyrslu.',
    gpuBindError: 'vfio-pci binding mistókst á {address}: {error}',

    // Firewall su bridge non gestiti (#168 §9-bis): la lista del consenso.
    firewallBridgesTitle: 'Eldveggur á óstýrðum brúm',
    firewallBridgesSubtitle: 'Handsmíðaðar brýr á þessum hnút þar sem uppsetningin samþykkir eldveggs-chains sem TVirt gerir á tengdum guest-NIC',
    firewallBridgesHint: 'TVirt snertir aldrei framandi brúna — chain-ið festist á tap/veth, sem er alltaf í eigu TVirt. Listinn er samþykkishlið: default-deny og anti-spoof geta brotið það sem handvirk uppsetning væntir, svo NIC með eldvegg á óstýrðri brú sem er EKKI á listanum er hafnað með talandi villu.',
    firewallBridgesEmpty: 'Engin óstýrð brú samþykkir eldveggs-chains sem TVirt gerir á þessum hnút.',
    firewallBridgeAdd: 'Bæta við brú',
    firewallBridgeInvalid: 'Ekki nafn á Linux-tengi (1-15 stafir, hvorki skástrik né bil)',
    firewallBridgeDuplicate: 'Nafnið er þegar á listanum',
    colMarkDevice: 'Eftir tæki',
    colMarkPort: 'Eftir porti',
    usbHub: 'hub',
    colUsbId: 'Vendor:Product',
    colPort: 'Port',
    passthroughOrphan: 'munaðarlaust — skráð en finnst ekki lengur: tengdu það aftur eða afmerktu það',
    noGpus: 'Engin GPU enn athuguð',
    noUsb: 'Ekkert USB-tæki enn athugað',
    networkGeneration: 'Netkynslóð',
    applied: 'Framkvæmd',
    converged: 'samstíga',
    behind: 'á eftir — {m} / {n}',
    notConfigured: 'ekki stillt',
    rollbackBody: 'Framkvæmd kynslóðar {gen} mistókst: {error}',
    rolledBackChip: 'rollback framkvæmt',
    nicsTitle: 'NIC',
    nicsSubtitle:
      'Skráin yfir stýrðar NIC — skráningin ER stjórnunaryfirlýsingin: skráð NIC án stillinga er ekki snert (clear-if lýsir hana skýrt hreina), óskráð tæki er aldrei snert',
    addNic: 'Skrá NIC',
    addNicTitle: 'Skrá NIC (add-nic)',
    delNic: 'Ljúka stjórnun',
    delNicTitle: 'Ljúka stjórnun (del-nic)',
    delNicConfirm:
      'Stjórnun {name} lýkur: skráarfærslan og stillingar hennar eru þurrkaðar út og TVirt-prófíllinn fjarlægður — tækið stendur eftir eins og Linux hefur það.',
    nicName: 'Nafn tækisins',
    nicMac: 'Varanlegt MAC-vistfang',
    nicMacHint: 'varanlega vélbúnaðar-MAC-ið — stöðuga auðkennið fest af TVirt Server Installer',
    colObserved: 'Athuguð',
    nicObserved: 'athuguð',
    nicNotObserved: 'ekki athuguð',
    nicMacMismatch: 'MAC víkur frá — athugað {mac}',
    noNics: 'Engin NIC skráð — skráðu tæki til að hefja stjórnun þess',
    noManagedDevices: 'Ekkert stýrt tæki — skráðu fyrst NIC, allt byggist á skránni',
    inventoryTitle: 'Athuguð tæki',
    inventorySubtitle: 'Uppfærð á hverri samræmingarumferð af worker hnútsins — löggildingin sannreynir tækjanöfnin á þessu yfirliti',
    colDevice: 'Tæki',
    colType: 'Tegund',
    colMac: 'MAC',
    colLink: 'Link',
    colSpeed: 'Hraði',
    colTopology: 'Uppbygging',
    colMtu: 'MTU',
    colAddresses: 'Vistföng',
    linkUp: 'up',
    linkDown: 'down',
    lacpDegraded: 'LACP safnar ekki saman',
    noInventory: 'Ekkert tæki tilkynnt hingað til',
    interfacesTitle: 'Tengi',
    interfacesSubtitle:
      'L3-stillingar skráðra NIC-a og yfirlýstra rökrænna tækja — set-if skiptir út allri blokkinni, edit-if lagar eiginleikana, clear-if tæmir hana (skýr hreinsun)',
    colConfig: 'Óskaðar stillingar',
    clean: 'hrein',
    setIf: 'Breyta vistföngum',
    setIfTitle: 'Breyta vistföngum (set-if)',
    editIf: 'Breyta eiginleikum',
    editIfTitle: 'Breyta eiginleikum (edit-if)',
    clearIf: 'Tæma stillingar',
    clearIfTitle: 'Tæma stillingar (clear-if)',
    clearIfConfirm: 'Stillingar tengisins eru tæmdar. Hreint tengi er forsenda þess að gera það að meðlim í bond/brú eða foreldri VLAN-s.',
    ip4Mode: 'IPv4-hamur',
    ip6Mode: 'IPv6-hamur',
    modeUnconfigured: 'Óstillt',
    modeStatic: 'Fast',
    modeDhcp: 'DHCP',
    ip4Addresses: 'IPv4-vistföng',
    ip6Addresses: 'IPv6-vistföng',
    addressesHint: 'CIDR, aðskilin með kommu',
    gw4: 'IPv4-gátt',
    gw6: 'IPv6-gátt',
    dns: 'DNS-þjónar',
    dnsHint: 'aðskildir með kommu — autt núllstillir DNS (set-if skiptir blokkinni út)',
    routes4: 'Fastar IPv4-leiðir',
    routes6: 'Fastar IPv6-leiðir',
    routeTo: 'Áfangastaður (CIDR)',
    routeVia: 'Um',
    addRoute: 'Bæta við leið',
    routesChip: 'leiðir',
    mtu: 'MTU',
    mtuHint: 'autt = sjálfgefið gildi rekilsins',
    vlansTitle: 'VLAN',
    addVlan: 'Bæta við VLAN',
    addVlanTitle: 'Bæta við VLAN (add-vlan)',
    delVlanTitle: 'Eyða VLAN (del-vlan)',
    vlanParent: 'Foreldratengi',
    vlanId: 'VLAN-ID',
    vlanPreview: 'Nafn tækisins',
    colParent: 'Foreldri',
    colVlanId: 'ID',
    noVlans: 'Ekkert VLAN yfirlýst',
    bondsTitle: 'Bond',
    addBond: 'Bæta við bondi',
    addBondTitle: 'Bæta við bondi (add-bond)',
    editBondTitle: 'Breyta bondi',
    editBond: 'Vista bond',
    delBondTitle: 'Eyða bondi (del-bond)',
    bondName: 'Nafn bondsins',
    members: 'Meðlimir',
    membersHint: 'meðlimirnir verða að vera hrein tengi (án L3-stillinga)',
    bondMode: 'Hamur',
    modeActiveBackup: 'active-backup',
    modeLacp: 'LACP (802.3ad)',
    miimon: 'miimon (ms)',
    primary: 'Aðalmeðlimur',
    rate: 'LACP-hraði',
    hash: 'Hash-stefna í sendingu',
    colMembers: 'Meðlimir',
    colMode: 'Hamur',
    noBonds: 'Ekkert bond yfirlýst',
    bridgesTitle: 'Brýr',
    addBridge: 'Bæta við brú',
    addBridgeTitle: 'Bæta við brú (add-bridge)',
    editBridgeTitle: 'Breyta brú',
    editBridge: 'Vista brú',
    delBridgeTitle: 'Eyða brú (del-bridge)',
    bridgeName: 'Nafn brúarinnar',
    stp: 'STP',
    stpOn: 'STP virkt',
    stpOff: 'STP óvirkt',
    colStp: 'STP',
    noBridges: 'Engin brú yfirlýst',
    hostnameTitle: 'Hýsilnafn',
    hostname: 'Hýsilnafn',
    setHostname: 'Setja hýsilnafn',
    setHostnameTitle: 'Setja hýsilnafn (set-hostname)',
    hostnameHint: 'Aðeins OS-auðkenni — nafn hnútsins í klasanum er ekki snert',
    notSet: 'ekki sett',
    staticHostsTitle: 'Fastar hýsilfærslur',
    addStaticHost: 'Bæta við færslu',
    addStaticHostTitle: 'Bæta við fastri hýsilfærslu',
    delStaticHostTitle: 'Eyða fastri hýsilfærslu',
    hostIp: 'IP-tala',
    hostNames: 'Nöfn',
    hostNamesHint: 'aðskilin með kommu eða bili',
    colIp: 'IP',
    colNames: 'Nöfn',
    noStaticHosts: 'Engin föst hýsilfærsla',
    delConfirm: '{name} er fjarlægt úr óskaða skjalinu — worker hnútsins rennur saman með NetworkManager-checkpoint og sjálfvirku rollback-i.',
    remove: 'Fjarlægja',
    opError: 'Netaðgerðinni var hafnað'
  }
}
